<template>
	<div class="member">
		<div class="banner">
			<img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/banner-member.jpg" />
			<div class="text">
				<img src="../../assets/images/banner-member-text.png" />
			</div>
		</div>
		<div class="block-wrap">
      <Breadcrumbs :routes="breadRoutes" />
      <div class="content-wrap">
				<!-- <div class="block-card">
					<div class="block-card-detail">
						<div class="block-card-detail-info">
							<h3>{{mainCard.orgName}}</h3>
							<div class="block-card-detail-info-desc">
								{{mainCard.memIntroduction || mainCard.orgName}}
							</div>
							<div class="card-more" @click="linkTo(`/member/detail?id=${mainCard.id}`)">查看详情</div>
						</div>
						<div class="block-card-detail-img">
							<img :src="mainCard.logoUrl" alt="">
						</div>
					</div>
					<div class="block-card-nav">
						<div class="block-card-nav-item"
									v-for="(item, index) in navs"
									:key="index">
							<img :src="item.imgSrc" alt="">
							<span class="block-card-nav-item-title">{{item.title}}</span>
							<span class="block-card-nav-item-desc">{{item.desc}}</span>
						</div>
					</div>
				</div>
				<SplitLine style="margin:30px 0px 15px 0px"/> -->
				<div>
					<div class="flex">
						<div class="types-wrap">
							<div class="type-item"
										:class="item.id === memType ? 'active' : ''"
										v-for="(item, index) in memTypes"
										:key="index"
										@click="onMemTypeChange(item)">{{item.name}}</div>
						</div>
						<!-- <div class="notice-wrap">
							<img src="../../assets/images/icon-notice-active.png" alt="">
							<p>珍爱湿地 人与自然和谐共生，世界湿地日。</p>
						</div> -->
						<div class="search-box">
							<input type="text" placeholder="请输入会员名称搜索" v-model="searchName"/>
							<div class="search-btn" @click="searchData">搜索</div>
						</div>
					</div>
					<div class="card-list-wrap">
						<div class="card-item hand" 
									v-for="(item, index) in listData"
									:key="index"
									@click="linkTo(`/member/detail?id=${item.id}`)">
							<div class="card-item-img">
								<img :src="item.logoUrl " alt="">
							</div>
							<div class="card-item-detail">
								<div class="card-item-detail-header">
									<h4 class="card-item-detail-header-title" :title="item.orgName">
										{{item.orgName || '-'}}
									</h4>
								</div>
								<div class="card-item-detail-body">
									{{item.memIntroduction || item.orgName}}
								</div>
								<div class="card-item-detail-footer">
									<div class="card-item-detail-footer-item">{{item.orgTypeDicValue || '-'}}</div>
									<span>｜</span>
									<div class="card-item-detail-footer-item">入会日期: {{item._joinDate}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="">
						<Pagination
							:currentPage="currentPage"
							:total="total"
							:pagesize="12"
							@change="pageChange"
						/>
					</div>
				</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import router from '@/router';
import Breadcrumbs from "@/components/Breadcrumbs";
import Pagination from '@/components/Pagination';
import { getMemList, getMemFirst } from './service/api';
import Icon1 from '../../assets/images/icon-member-1.png';
import Icon2 from '../../assets/images/icon-member-2.png';
import Icon3 from '../../assets/images/icon-member-3.png';
import Icon4 from '../../assets/images/icon-member-4.png';
import Icon5 from '../../assets/images/icon-member-5.png';
import Icon6 from '../../assets/images/icon-member-6.png';
import Icon7 from '../../assets/images/icon-member-7.png';
import Icon8 from '../../assets/images/icon-member-8.png';
import tempCoverImg from '@/assets/tempImages/member-demo.jpeg';
export default {
  data() {
    return {
    	breadRoutes: [{
    		href: '/',
    		name: '首页'
    	}, {
    		name: '会员之家'
    	}],
			navs: [{
				imgSrc: Icon1,
				title: '会员类型',
				desc: ''
			}, {
				imgSrc: Icon2,
				title: '入会日期',
				desc: ''
			}, 
			// {
			// 	imgSrc: Icon3,
			// 	title: '会员特点3',
			// 	desc: '特点介绍'
			// }, {
			// 	imgSrc: Icon4,
			// 	title: '会员特点4',
			// 	desc: '特点介绍'
			// }, {
			// 	imgSrc: Icon5,
			// 	title: '会员特点5',
			// 	desc: '特点介绍'
			// }, {
			// 	imgSrc: Icon6,
			// 	title: '会员特点6',
			// 	desc: '特点介绍'
			// }, {
			// 	imgSrc: Icon7,
			// 	title: '会员特点7',
			// 	desc: '特点介绍'
			// }, {
			// 	imgSrc: Icon8,
			// 	title: '会员特点8',
			// 	desc: '特点介绍'
			// }
			],
			mainCard: {},
			memTypes: [
        {
          name: "全部",
          id: 'org',
        },
				{
          name: "常务理事单位",
          id: 'org1501',
        },
				{
          name: "理事单位",
          id: 'org1502',
        },
				{
          name: "团体会员",
          id: 'org1503',
        },
        // {
        //   name: "个人会员",
        //   id: 'personal',
        // }
      ],
      listData: [],
      memType: 'org',
      currentPage: 1,
      pageSize: 12,
      total: 0,
			searchName: ''
    }
  },
  components: {
    Breadcrumbs,
    Pagination
  },
	mounted() {
		this.init();
	},
  methods: {
		init() {
			getMemFirst().then(res => {
				this.mainCard = res;
				this.navs[0].desc = res.orgTypeDicValue || '-';
				this.navs[1].desc = res.joinDate ? moment(res.joinDate*1000).format(
					"YYYY-MM-DD"
				) : '-';
				if(!res.logoUrl ){
					res.logoUrl = tempCoverImg
				}
				
			});

			this.getList();
		},
		onMemTypeChange(item) {
      this.memType = item.id;
			this.currentPage = 1;
      this.getList();
    },
    getList() {
      const params = {
				searchName: this.searchName,
        current: this.currentPage,
        pageSize: this.pageSize,
        memType: this.memType,
      };
      getMemList(params).then((res) => {
        this.total = res.totalResult;
        this.listData = (res.list || []).map((item) => {
          item._joinDate = item.joinDate ? moment(item.joinDate*1000).format(
            "YYYY-MM-DD"
          ) : '-';
					if(!item.logoUrl ){
						item.logoUrl = tempCoverImg
					}
          return item;
        });
      });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
		linkTo(uri) {
      router.push(uri);
    },
		searchData() {
      this.pageChange(1);
    },
  }
}

</script>
<style lang="less" scoped>
@import '../../assets/less/global.less';

.banner {
	width: 100%;
	min-width: @middleWidth;
	margin-bottom: 20px;
	position: relative;

	img {
		display: block;
		width: 100%;
	}

	.text {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);

		> img {
			width: 297px;
		}
	}
}
.flex {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 22px;
}
.types-wrap {
  display: flex;
  align-items: center;

  .type-item {
    width: 120px;
    text-align: center;
		height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		line-height: 40px;
    color: #131415;
		border-bottom: 6px solid #F1F3F3;
		cursor: pointer;

    &.active {
      color: #06AE63;
			border-color: #06AE63;
    }
  }
}

.notice-wrap {
	padding: 6px 14px;
	height: 32px;
	background: rgba(6, 174, 99, 0.1);
	border-radius: 4px;
	display: flex;
	align-items: center;

	img {
		width: 17px;
		margin-right: 10px;
	}

	p {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #0A2312;
	}
}

.content-wrap {
	padding-top: 30px;
	padding-bottom: 54px;
}
.block-card {
	height: 330px;
	position: relative;
	background: url(../../assets/images/member-card-bg.png) no-repeat center center;
	background-size: 100% 100%;
	padding: 0 60px 23px 60px;
	display: flex;
	align-items: flex-end;

	&-detail {
		width: 1080px;
		height: 215px;
		position: absolute;
		left: 60px;
		top: -30px;
		background: #FFFFFF;
		box-shadow: 0px 8px 11px 0px rgba(0,0,0,0.1600);
		border: 1px solid #E3E3E3;
		padding: 30px 75px 20px;
		display: flex;
		justify-content: space-between;

		&-info {
			display: flex;
			flex-direction: column;

			h3 {
				&:extend(.line1);
				height: 25px;
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #131415;
				line-height: 25px;
				margin-bottom: 9px;
			}

			&-desc {
				&:extend(.line3);
				width: 520px;
				height: 72px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #787878;
				line-height: 24px;
			}

			.card-more {
				margin-top: auto;
			}
		}

		&-img {
			width: 339px;
			height: 173px;
			background: #06AE63;
			align-self: flex-end;

			img {
				width: 100%;
				height: 100%;
				display: block;
				transform: translate(-18px, -12px);
			}
		}
	}

	&-nav {
		width: 100%;
		display: flex;

		&-item {
			width: 110px;
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;

			img {
				width: 60px;
				height: 60px;
				margin-bottom: 4px;
			}

			&-title {
				height: 20px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 20px;
				margin-bottom: 2px;
			}

			&-desc {
				&:extend(.line1);
				width: 100%;
				text-align: center;
				height: 17px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 17px;
			}
		}
	}
}
.card-list-wrap {
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .card-item {
    width: 285px;
		margin-right: 20px;
    position: relative;
    display: flex;
    align-items: center;
		flex-direction: column;
		margin-bottom: 20px;

    &:nth-child(4n) {
    	margin-right: 0;
    }

    &-img {
      width: 100%;
			height: 164px;

      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    &-detail {
			width: 100%;
			height: 191px;
			background: #FDFFFD;
			border: 1px solid #E1E1E1;
      display: flex;
      flex-direction: column;
			padding: 20px;
			padding-bottom: 10px;

      &-header {
        display: flex;
        align-items: center;
        height: 25px;
        margin-bottom: 15px;

        &-title {
					&:extend(.line1);
          flex: 1;
					font-size: 18px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #131415;
        }
      }

      &-body {
        &:extend(.line3);
				height: 72px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #787878;
				line-height: 24px;
      }

      &-footer {
        margin-top: auto;
        display: flex;
        align-items: center;
				height: 24px;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #787878;
				line-height: 24px;

        &-item {
					cursor: pointer;
				}
      }
    }
  }
}
.search-box {
  height: 31px;
  display: flex;
  // margin-bottom: 23px;

  input {
    width: 243px;
    height: 31px;
    background: #f1f3f3;
    border: none;
    padding: 6px 15px;
    box-sizing: border-box;
  }

  .search-btn {
    width: 95px;
    height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06ae63;
    font-size: 14px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }
}
</style>